<div class="modal-header">
  <h3 class="modal-title">Select clients</h3>
  <button
    type="button"
    class="close"
    (click)="close()"
    aria-label="Close"
    tabindex="1">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group row">
    <div class="col-sm-12">
      <kendo-multiselect
        class="field-multi-select fields-multiselect"
        placeholder="Select clients where I am"
        [data]="responsibles"
        textField="name"
        valueField="id"
        [valuePrimitive]="false"
        [filterable]="false"
        (valueChange)="valueChange($event)"></kendo-multiselect>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-12">
      <app-organization-search
        (selectedOrganizationsChange)="changeFilter($event)"
        [indent]="10"
        [includeType]="true"
        [showTags]="true"
        [onlyUserOrgs]="true"
        [retainPreviousSearch]="false"
        [debounceEnabled]="true"
        [placeholder]="'Select clients by organization unit'"
        [enabledLevels]="enabledOrganizationLevels"></app-organization-search>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-12">
      <app-searchable-list-micro
        [resourceUrl]="clientsUrl"
        [config]="clientConfig"
        [selectedItems]="clients"
        (changeValue)="persistedClients($event)"
        tabindex="2"></app-searchable-list-micro>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-secondary btn-sm"
    (click)="close()"
    tabindex="3">
    Cancel
  </button>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="save()"
      tabindex="4">
      Done
    </button>
  </div>
</div>
